import { render, staticRenderFns } from "./EmailGroupPage.vue?vue&type=template&id=580b0f2e&scoped=true&"
import script from "./EmailGroupPage.vue?vue&type=script&lang=js&"
export * from "./EmailGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./EmailGroupPage.vue?vue&type=style&index=0&id=580b0f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b0f2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580b0f2e')) {
      api.createRecord('580b0f2e', component.options)
    } else {
      api.reload('580b0f2e', component.options)
    }
    module.hot.accept("./EmailGroupPage.vue?vue&type=template&id=580b0f2e&scoped=true&", function () {
      api.rerender('580b0f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/email/EmailGroupPage.vue"
export default component.exports